// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.
import React from 'react';
import { Grid } from '@mui/material';
import {
  DiscardChangesButton,
  ScenarioExportButton,
  StopRunButton,
  SaveButton,
  LaunchButton,
  RunningStateSpinner,
} from './components';

export const ScenarioActions = () => {
  return (
    <Grid container spacing={1} alignItems="center">
      <RunningStateSpinner />
      <ScenarioExportButton />
      <StopRunButton />
      <DiscardChangesButton />
      <SaveButton />
      <LaunchButton />
    </Grid>
  );
};
